import _sfc_main from "./TuiSwitch.vue2.mjs";
/* empty css                */
import normalizeComponent from "../../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { class: [_setup.props.value ? "switch-container" : "switch-container-active"], on: { "click": _setup.toggleSwitch } }, [_c("div", { staticClass: "switch-core" })]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "efa68e90"
);
const TuiSwitch = __component__.exports;
export {
  TuiSwitch as default
};
